import { memo } from "react";
import { useDrop } from "react-dnd";
import { Typography } from "@material-ui/core";
import { PeriodComponents } from "./TermTemplateComponents.js";
import AddPeriodToTemplateDialog from "./AddPeriodToTemplateDialog.js";

export const PeriodDropBox = memo(function PeriodDropBox({
  lastDroppedComponent,  
  closeAddDialog,
  onDrop,
  passObjOptions,
}) {
  
  const [{ isOver, canDrop }, drop] = useDrop({
    accept: [PeriodComponents.PERIOD],
    drop(_item, monitor) {
      onDrop(monitor.getItemType());
      return undefined;
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
      draggingColor: monitor.getItemType(),
    }),
  });

  return (
    <div
      ref={drop}
      role="PeriodDropBox"
      style={{
        width: 147,
        border: "1px dashed grey",
        borderRadius: "8px",
        height: "70px",
        textAlign: "center",
        display: "flex",
      }}
    >
      <Typography
        variant="h6"
        style={{
          display: "flex",
          alignItems: "center",
          padding: 5,
        }}
      >
        Drag and drop Period object into this box.
      </Typography>
      {!canDrop && lastDroppedComponent === "Period" && (
        <AddPeriodToTemplateDialog
          closeDialog={closeAddDialog}
          handleAddPeriodToTemplate={passObjOptions}          
        />
      )}
    </div>
  );
});
